module.exports = __webpack_public_path__ + "static/media/icon_172.6653efbc.svg";